// data for this code located at Media/script
//http://devc1.gpm.westernunion.com/media/cedc8ba8-24b1-4d14-a65b-9f9c92b64b5c?download=false
module.exports = (function ($, window, document, undefined) {
  "use strict";
  var self;

  // Create the defaults once
  var pluginName = "gpmRefundForm",
    defaults = {
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    self = this;
    this.element = element;
    this.settings = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    init: function () {
      console.log('Refund Form v.2022.01.27');
      String.prototype.format = function () {
        var args = arguments;
        return this.replace(/\{\{|\}\}|\{(\d+)\}/g,
          function (m, n) {
            if (m === "{{") {
              return "{";
            }
            if (m === "}}") {
              return "}";
            }
            return args[n];
          });
      };

      //Variables
      self.$el = $(this.element);
      self.Form = $('.formbuilder');
      self.Culture = $('body').data('culture');

      self.FirstName = $('#FirstName');
      self.LastName = $('#LastName');

      self.BankCountry = $('#BankCountry');
      self.BankState = $('#BankState');
      self.Country = $('#Country');
      self.State = $('#State');
      self.Currency = $('#Currency');
      self.AccountNumber = $('#AccountNumber');
      self.RoutingCode = $('#RoutingCode');
      self.abbr = '<abbr title=" is a mandatory field"></abbr>';

      //Bindings
      //self.FirstName.change($.proxy(self.setBankAccountName, self));
      //self.LastName.change($.proxy(self.setBankAccountName, self));

      // Defaults
      self.BankCountry.unbind();
      self.BankCountry.select2();
      self.BankCountry.change($.proxy(self.BankCountryChanged, self));
      self.Country.change($.proxy(self.CountryChanged, self));
      self.loadCurrencies();
      self.loadCountries();
      self.BankCountryChanged();

      setTimeout(function () {
        console.log('trigger change');
        $("#BankCountry").trigger('change');
      }, 1000);

    },
    ProcessData: function (country) {
      self.setDropDownValue("#Currency", $("#BankCountry option[value=" + $("#BankCountry").val() + "]").data("currency"));
      if (typeof (countryFieldsData) != 'undefined') {
        if (country in countryFieldsData) {
          var data = self.BankCountry.val() === null ? countryFieldsData['default'] : countryFieldsData[country];
          $.each(data, function (fieldName, fieldProperties) {

            console.log('ProcessData: ' + country + ': ' + fieldName + ' ');

            $.each(fieldProperties, function (attributeName, attributeValue) {
              switch (attributeName) {
                case "Mask":
                  self.setMask($(fieldName), attributeValue);
                  break;
                case "RegExpr":
                  self.setRegExpr(fieldName, attributeValue);
                  break;
                case "Label":
                  $('label[for=' + fieldName.substring(1, fieldName.length) + ']').text(attributeValue);
                  break;
                case "Help":
                  self.setHelp(fieldName, attributeValue);
                  break;
                case "DefaultValue":
                  switch (fieldName) {
                    case "#BankCountry":
                    case "#Currency":
                      self.setDropDownValue($(fieldName), attributeValue);
                      break;
                    default:
                      $(fieldName).val(attributeValue);
                      break;
                  }
                  break;
                case "Show":
                  self.setShow(fieldName, attributeValue);
                  break;
                case "ReadOnly":
                  self.setReadOnly(fieldName, attributeValue);
                  break;
                case "Required":
                  self.setRequired(fieldName, attributeValue);
                  break;
                case "EnabledOptions":
                  self.setEnabledOptions(fieldName, attributeValue);
                  break;
              }
            });
          });
        }
      }
    },
    BankCountryChanged: function () {
      self.ProcessData('default');
      self.ProcessData(self.BankCountry.val());
      self.loadStates(self.BankCountry, self.BankState, '#BankState option', '#BankState-group');

      self.setDropDownValue(self.Country, self.BankCountry.val());
      self.loadStates(self.Country, self.State, '#State option', '#State-group');
    },
    CountryChanged: function () {
      self.loadStates(self.Country, self.State, '#State option', '#State-group');
    },
    loadCurrencies: function () {
      $.ajax({
        url: '/api/formbuilder/{0}/currencies'.format(self.Culture),
        dataType: 'json',
        type: 'get',
        success: function (json) {
          self.Currency.select2('data', null);

          $.each(json, function (index, value) {
            self.Currency.append($('<option>').text(value.Title).val(value.Code).attr('data-symbol', value.Symbol));
          });

          self.Currency.val(self.Currency.data('default-value')).trigger('change.select2');
        }
      });
    },
    loadCountries: function () {
      $.ajax({
        url: '/api/formbuilder/{0}/countries'.format(self.Culture),
        dataType: 'json',
        type: 'get',
        success: function (json) {
          $.each(json, function (index, value) {
            $('#BankCountry option[value="' + value.Code + '"]').attr("data-currency", value.CurrencyCode);
          });
        }
      });
    },
    loadStates: function (country, state, stateOption, stateGroup) {
      $(stateOption).remove();
      $(stateGroup).hide();

      var defaultValue = state.attr('data-default-value');
      var countryValue = country.val();
      if (countryValue) {
        $.ajax({
          url: "/WebServices/Library/FormBuilder/State.ashx",
          dataType: 'json',
          data: "operation=List&Country=" + countryValue + "&Culture=" + state.attr('data-culture'),
          type: "get",
          success: function (json) {
            $.each(json, function (i, value) {
              state.append($('<option>').text(value.Title).attr('value', value.Code));
            });
            if ($(stateOption).length > 0) {
              var field = '#' + state.attr('id');
              var countryData = countryFieldsData[country.val()];
              var fieldData = countryData[field];

              if (typeof fieldData != 'undefined' && fieldData.Show) {
                $(stateGroup).show();
                state.val(defaultValue).trigger('change');
              }
            }
          }
        });
      }
      return false;
    },
    setDropDownValue: function (control, value) {
      $(control).val(value).trigger('change.select2');
    },
    //setBankAccountName: function () {
    //    var fullName = '{0} {1}'.format(self.FirstName.val(), self.LastName.val());
    //    $('#BankAccountName, #ContactName').val(fullName);
    //},
    setMask: function (control, value) {
      if ($(control).length) {
        if (value === '') {
          if (typeof ($(control).inputmask("getmetadata")) !== 'undefined') {
            console.log('setMask empty to: ' + control + ' value "' + control.val() + '"');
            $(control).inputmask('remove');
          }
        }
        else {
          $(control).inputmask(value, { clearMaskOnLostFocus: false, removeMaskOnSubmit: false, greedy: false, clearIncomplete: true, showMaskOnHover: false });
        }
      } else {
        console.log('setMask: ' + control + ' not exists');
      }
    },
    setRegExpr: function (control, value) {
      if ($(control).length) {
        var method = $(control).attr('id').replace('#', '');
        if (value === '') {
          $.validator.addMethod(method, function (value, element) {
            return true;
          }, "");
        }
        else {
          var label = $(control + '-group label').html();

          if (label.indexOf(self.abbr) > 0) {
            label = label.replace(self.abbr, '')
          }

          $.validator.addMethod(method, function (v, element) {
            var regExpr = new RegExp(value, "i");
            //console.log(value);
            //console.log(v);
            //console.log(regExpr.test(v));
            return this.optional(element) || regExpr.test(v);
          }, "{0} is invalid".format(label));
        }
      } else {
        console.log('setRegExpr: ' + control + ' not exists');
      }
    },
    setDisabled: function (control, value) {
      if ($(control).length) {
        $(control).attr('disabled', value);
      } else {
        console.log('setDisabled: ' + control + ' not exists');
      }
    },
    setShow: function (control, value) {
      if ($(control).length) {
        if (value) {
          $(control + '-group').show();
        }
        else {
          $(control + '-group').hide();
        }
      } else {
        console.log('setShow: ' + control + ' not exists');
      }
    },
    setReadOnly: function (control, value) {
      if ($(control).length) {
        if (value) {
          $(control).attr('readonly', value);
        }
        else {
          $(control).removeAttr('readonly');
        }
      } else {
        console.log('setReadOnly: ' + control + ' not exists');
      }
    },
    setRequired: function (control, value) {
      if ($(control).length) {
        var label = $(control + '-group label');
        if (value) {
          $(control).addClass('required');
          $(control + '-group').addClass('required');

          //to avoid doubles
          if (label.html().indexOf(self.abbr) < 0) {
            label.append(self.abbr);
          }
        }
        else {
          $(control).removeClass('required');
          $(control + 'group').removeClass('required');
          if (typeof label.html() !== 'undefined') {
            label.html(label.html().replace(self.abbr, ''));
          }
        }
      } else {
        console.log('setRequired: ' + control + ' not exists');
      }
    },
    setHelp: function (control, value) {
      if ($(control).length) {
        if ($(control + '-group .help-block').length == 0) {
          var help = '<p class="help-block"></p>';
          $(control + '-group').append(help);
        }
        self.setHtml($(control + '-group .help-block'), value);
      } else {
        console.log('setHelp: ' + control + ' not exists');
      }
    },
    setHtml: function (control, value) {
      if ($(control).length) {
        $(control).html(value);
      } else {
        console.log('setHtml: ' + control + ' not exists');
      }
    },
    setEnabledOptions: function (control, value) {
      if ($(control).length) {
        if (value == '') {
          $(control + ' option').removeAttr('disabled');
        }
        else {
          $(control + ' option').prop('disabled', true);
        }

        if (value != '') {
          var values = value.split(',');
          for (var i = 0; i < values.length; i++) {
            $(control + ' option[value=' + values[i] + ']').prop('disabled', false);
          }
        }

        $(control).select2();
      } else {
        console.log('setEnabledOptions: ' + control + ' not exists');
      }
    }
  });

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  };

})(jQuery, window, document);
